import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'tpc-vehicle',
    templateUrl: './vehicle.component.html',
    styleUrls: ['./vehicle.component.css']
})
export class VehicleComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/shared/main/vehicle/vehicle.component.ts